import { render, staticRenderFns } from "./TrialCancellationActionsUi.vue?vue&type=template&id=b7b96fc6&scoped=true&"
import script from "./TrialCancellationActionsUi.vue?vue&type=script&lang=ts&"
export * from "./TrialCancellationActionsUi.vue?vue&type=script&lang=ts&"
import style0 from "./TrialCancellationActionsUi.vue?vue&type=style&index=0&id=b7b96fc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b96fc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b7b96fc6', component.options)
    } else {
      api.reload('b7b96fc6', component.options)
    }
    module.hot.accept("./TrialCancellationActionsUi.vue?vue&type=template&id=b7b96fc6&scoped=true&", function () {
      api.rerender('b7b96fc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/cancellation/components/TrialCancellationActionsUi.vue"
export default component.exports